import { ChainId as InjectiveChainId } from "@injectivelabs/ts-types";
import { WalletErrorType } from "../../shared/error";
import { base64Image } from "./icon";
import { okxWallet } from "../okx";
const injectiveErrors = [
    {
        message: "User rejected the request.",
        type: WalletErrorType.rejected,
    },
    {
        // XDEFI proxy will throw an empty message error when access rejecting
        message: "",
        type: WalletErrorType.rejected,
    },
];
const walletInfo = {
    name: "MetaMask",
    icon: base64Image,
    install: {
        chrome: "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn",
        firefox: "https://addons.mozilla.org/en-US/firefox/addon/ether-metamask",
        edge: "https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm",
        ios: "https://apps.apple.com/us/app/metamask-blockchain-wallet/id1438144202",
        android: "https://play.google.com/store/apps/details?id=io.metamask",
    },
    isChainSupported: (chainId) => {
        switch (chainId) {
            case InjectiveChainId.Mainnet:
            case InjectiveChainId.Testnet:
            case InjectiveChainId.Devnet:
                return true;
            default:
                return false;
        }
    },
    errors: {
        generic: [
            {
                message: "User rejected the request",
                type: WalletErrorType.rejected,
            },
            {
                message: "User denied transaction",
                type: WalletErrorType.rejected,
            },
            {
                message: "MetaMask Typed Message Signature: User denied message signature.",
                type: WalletErrorType.rejected,
            },
        ],
        chain: {
            // Include proxy wallet errors
            [InjectiveChainId.Mainnet]: [
                ...(okxWallet.info.errors.chain?.[InjectiveChainId.Mainnet] ?? []),
                ...injectiveErrors,
            ],
            [InjectiveChainId.Testnet]: [
                ...(okxWallet.info.errors.chain?.[InjectiveChainId.Testnet] ?? []),
                ...injectiveErrors,
            ],
            [InjectiveChainId.Devnet]: [
                ...(okxWallet.info.errors.chain?.[InjectiveChainId.Devnet] ?? []),
                ...injectiveErrors,
            ],
        },
    },
};
export const metaMaskWallet = {
    provider: () => {
        const installed = typeof window.ethereum !== "undefined";
        if (!installed) {
            return { installed };
        }
        return {
            installed,
        };
    },
    info: walletInfo,
};
//# sourceMappingURL=index.js.map